import { _CollectionType } from "apollo/graphql.generated";

export { collectionTypeDisplayName as collectionTypeToDisplayName } from "@hl/shared-features/lib/features/collections/display-utils";

export const generateNextCollectionRevision = (collectionName: string) => {
  const revisionPrefix = "v";
  const revisionRegex = new RegExp(`${revisionPrefix}\\d+`);
  const currentNameRevision = +(
    collectionName.match(revisionRegex)?.[0].substring(1) || "0"
  );

  return currentNameRevision > 0
    ? collectionName.replace(
        revisionRegex,
        `${revisionPrefix}${(currentNameRevision + 1).toString()}`
      )
    : `${collectionName} v2`;
};

export const isSeriesLikeCollection = (
  collectionType?: _CollectionType
): boolean =>
  !!collectionType &&
  (collectionType === _CollectionType.Series ||
    collectionType === _CollectionType.GenerativeSeries);

export const isGenSeriesCollection = (
  collectionType?: _CollectionType
): boolean =>
  !!collectionType && collectionType === _CollectionType.GenerativeSeries;

export const isSeriesCollection = (collectionType?: _CollectionType): boolean =>
  !!collectionType && collectionType === _CollectionType.Series;
